export * from './app.service';
import { AppService } from './app.service';
export * from './appMigrations.service';
import { AppMigrationsService } from './appMigrations.service';
export * from './avatar.service';
import { AvatarService } from './avatar.service';
export * from './chat.service';
import { ChatService } from './chat.service';
export * from './chatFiles.service';
import { ChatFilesService } from './chatFiles.service';
export * from './chatFilesGroup.service';
import { ChatFilesGroupService } from './chatFilesGroup.service';
export * from './chatManagement.service';
import { ChatManagementService } from './chatManagement.service';
export * from './chatMessages.service';
import { ChatMessagesService } from './chatMessages.service';
export * from './emodji.service';
import { EmodjiService } from './emodji.service';
export * from './logs.service';
import { LogsService } from './logs.service';
export * from './settings.service';
import { SettingsService } from './settings.service';
export * from './users.service';
import { UsersService } from './users.service';
export const APIS = [AppService, AppMigrationsService, AvatarService, ChatService, ChatFilesService, ChatFilesGroupService, ChatManagementService, ChatMessagesService, EmodjiService, LogsService, SettingsService, UsersService];
